import './App.css';
import './responsive.css';
import Home from './pages/Home';
import Login from './pages/Login';

import Dashboard from './pages/Dashboard';

import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import Aboutpage from './pages/Aboutpage';
import Contact from './pages/Contact';
import Result from './pages/Result';
import { HelmetProvider } from "react-helmet-async";
import AddResult from './pages/AddResult';
import ResultsTable from './pages/ResultsTable';
import Skilleducation from './pages/Skilleducation';
import Traditionaleducation from './pages/Traditionaleducation';
import Admission from './pages/Admission';
import ELearning from './pages/ELearning';
import Recognition from './pages/Recognition';
import Authorizedcenters from './pages/Authorizedcenters';
import Universitiesletters from './pages/Universitiesletters';
import Legalization from './pages/Legalization';
import Download from './pages/Download';
import Studentverification from './pages/Studentverification';
import NewsAdmin from './pages/NewsAdmin';
function App() {

  const checkIfUserIsLoggedIn = () => {
    return localStorage.getItem('user') !== null;

  }
  const isLoggedIn = checkIfUserIsLoggedIn();


  return (
    <div className="App">
       <HelmetProvider>
      <Router>
        <Routes>



          <Route path='/login' element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />
          <Route index element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/about' element={<Aboutpage />} />                  
          <Route path='/dashboard' element={<Dashboard />} />  
          <Route path='/contact' element={<Contact />} />
          <Route path='/result' element={<Result />} />
          <Route path='/AddResult' element={<AddResult />} />
          <Route path='/all-results' element={<ResultsTable />} />
          <Route path='/skill-education' element={<Skilleducation />} />
          <Route path='/traditional-education' element={<Traditionaleducation />} />
          <Route path='/admission' element={<Admission />} />
          <Route path='/e-learning' element={<ELearning />} />
          <Route path='/recognition' element={<Recognition />} />
          <Route path='/authorized-centers' element={<Authorizedcenters />} />
          {/* <Route path='*' element={<Navigate to="/home" />} /> */}
          <Route path='/universities-letters' element={<Universitiesletters />} />
          <Route path='/legalization' element={<Legalization />} />
          <Route path='/download' element={<Download />} />
          <Route path='/student-verification' element={<Studentverification />} />
           <Route path='/admin-news' element={<NewsAdmin />} />
        </Routes>
      </Router>

</HelmetProvider>

    </div>
  );
}

export default App;
